<template>
    <b-container fluid style="padding:10px">
        <b-jumbotron header="Photos">
            Behold! Photos that I'm generally proud of!
        </b-jumbotron>

        <b-card no-body class="overflow-hidden picture" style="max-width: 1000px;">
            <b-row no-gutters>
                <b-col md="8">
                    <b-card-img :src="require('../assets/austria-house.jpg')" alt="Image" class="rounded-0"></b-card-img>
                </b-col>
                <b-col md="4">
                    <b-card-body title="Overlook">
                        <b-card-sub-title class="mb-2">Saalfelden, Austria - 2018</b-card-sub-title>
                        <b-card-text>
                            One of my first photos, taken on a trip to Europe in 2018. The hut is a bed & breakfast
                            with coin operated showers. You literally rent half a bed.
                        </b-card-text>
                    </b-card-body>
                </b-col>
            </b-row>
        </b-card>

        <b-card no-body class="overflow-hidden picture" style="max-width: 1000px;">
            <b-row no-gutters>
                <b-col md="8">
                    <b-card-img :src="require('../assets/hk-skyline.jpg')" alt="Image" class="rounded-0"></b-card-img>
                </b-col>
                <b-col md="4">
                    <b-card-body title="Neon">
                        <b-card-sub-title class="mb-2">Hong Kong SAR - 2019</b-card-sub-title>
                        <b-card-text>
                            Taken immediately after the Lunar New Year firework celebration. Smoke from the fireworks
                            drifts over the harbor and Hong Kong Skyline. Taken from Kowloon.
                        </b-card-text>
                    </b-card-body>
                </b-col>
            </b-row>
        </b-card>

        <b-card no-body class="overflow-hidden picture" style="max-width: 1000px;">
            <b-row no-gutters>
                <b-col md="8">
                    <b-card-img :src="require('../assets/monkey-hand.jpg')" alt="Image" class="rounded-0"></b-card-img>
                </b-col>
                <b-col md="4">
                    <b-card-body title="Paparazzi">
                        <b-card-sub-title class="mb-2">Bali, Indonesia - 2019</b-card-sub-title>
                        <b-card-text>
                            This little guy was found in the Monkey Forest in Ubud. These monkeys are familiar with humans
                            since they are constantly visited by tourists.
                        </b-card-text>
                    </b-card-body>
                </b-col>
            </b-row>
        </b-card>

        <b-card no-body class="overflow-hidden picture" style="max-width: 1000px;">
            <b-row no-gutters>
                <b-col md="8">
                    <b-card-img :src="require('../assets/maui-framed.jpg')" alt="Image" class="rounded-0"></b-card-img>
                </b-col>
                <b-col md="4">
                    <b-card-body title="Sail">
                        <b-card-sub-title class="mb-2">Maui, Hawaii - 2019</b-card-sub-title>
                        <b-card-text>
                            I left my camera on high ISO this whole trip (rookie mistake) so most of my shots were grainy
                            from this trip. I was able to salvage a couple of the amazing sunsets over the ocean.
                        </b-card-text>
                    </b-card-body>
                </b-col>
            </b-row>
        </b-card>

        <b-card no-body class="overflow-hidden picture" style="max-width: 1000px;">
            <b-row no-gutters>
                <b-col md="8">
                    <b-card-img :src="require('../assets/nyc-buildings.jpg')" alt="Image" class="rounded-0"></b-card-img>
                </b-col>
                <b-col md="4">
                    <b-card-body title="Giant">
                        <b-card-sub-title class="mb-2">New York City - 2019</b-card-sub-title>
                        <b-card-text>
                            A candid photo of a photographer in Central Park. I'm not sure what about this photo made me
                            like it so much, but I love the contrast between the rock formation and buildings.
                        </b-card-text>
                    </b-card-body>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
    export default {
        name: "Photos"
    }
</script>

<style scoped>
 .picture {
     margin-top:5px;
     margin-bottom:5px
 }
</style>